import { html } from "lit";

export const globalEventTeaserData = {
    intro: "Intech - 09.-12. April 2024",
    headline: "Erleben Sie die TruLaser Cell 3000 live auf der Intech",
    subline: "Besuchen Sie uns an unserem Stand in Halle 4.1.",
    link: "#",
    linkText: "Zum Messespecial",
    icon: "calendar",
    iconSize: "64",
    image: "./mock-assets/images/blechexpo-logo.png",
    imageAltText: "Blechexpo Logo",
};

export function TeaserGlobalEventTemplate(args) {
    return html`
        <ux-iws-link-wrapper class="ux-iws-teaser-global-event">
            <div class="ux-iws-teaser-global-event__media-wrapper">
                ${args.media === "icon"
                    ? html`<ux-icon
                          name="${globalEventTeaserData.icon}"
                          size-s="${globalEventTeaserData.iconSize}"
                      />`
                    : html``}
                ${args.media === "image"
                    ? html`<img
                          src="${globalEventTeaserData.image}"
                          alt="${globalEventTeaserData.imageAltText}"
                      />`
                    : html``}
            </div>
            <div class="ux-iws-teaser-global-event__text-button-wrapper">
                <div class="ux-iws-teaser-global-event__text-wrapper">
                    <span
                        class="ux-iws-teaser-global-event__intro ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                    >
                        ${args.intro}
                    </span>
                    <h3
                        class="ux-iws-teaser-global-event__headline ux-text-headline ux-text-headline--small ux-u-text-bold"
                    >
                        ${args.headline}
                    </h3>
                    <p class="ux-iws-teaser-global-event__subline">
                        ${args.subline}
                    </p>
                </div>
                <div class="ux-iws-teaser-global-event__button-wrapper">
                    <a class="ux-button" href="${globalEventTeaserData.link}">
                        ${globalEventTeaserData.linkText}
                    </a>
                </div>
            </div>
        </ux-iws-link-wrapper>
    `;
}
